module.exports = __webpack_public_path__ + "static/media/Frame-10.704066c2.svg";